import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Field from '../Field';

export default props => {
  const { info, gender, ethnicity, email, phone } = props;
  const formatDate = date => (date ? moment(date).format('MM/DD/YYYY') : date);
  return (
    <Grid container spacing={2} style={{ flexGrow: 1 }}>
      <Grid item xs={12} id="BasicInfo-InfoPanel-firstName">
        <Field label="First Name" value={info.firstName} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Middle Initial" value={info.middleInitial} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Last Name" value={info.lastName} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Date of Birth" value={formatDate(info.birthDate)} />
      </Grid>
      <Grid item xs={12}>
        <Field
          label={
            (info.idType || '').toUpperCase() === 'SIN'
              ? 'Social Insurance Number'
              : 'Social Security Number'
          }
          value={info.socialSecurityMask}
        />
      </Grid>
      <Grid item xs={12}>
        <Field label="Gender" value={gender} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Ethnicity" value={ethnicity} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Email" value={email} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Phone Number" value={phone.cell} />
      </Grid>
    </Grid>
  );
};
